import React from "react";
import { fnGetValueByKey } from "../../helpers/functions";
import { Tooltip } from "reactstrap";
import TextWithTooltip from "./TextWithTooltip";

const CardFlowDynamic = ({ dataTree = null, flowData = null }) => {
  const [showTooltipName, setShowTooltipName] = React.useState(false);
  const getFlowItems = () => {
    if (dataTree) {
      const procedureResultSetString = fnGetValueByKey(
        dataTree,
        "PROCEDURE_RESULTSET"
      );
      if (procedureResultSetString) {
        try {
          return JSON.parse(procedureResultSetString);
        } catch (e) {
          console.error(
            "Erro ao fazer parse do PROCEDURE_RESULTSET no CardFlowDynamic:",
            e
          );
          return [];
        }
      }
    }
    return [];
  };

  const flowItems = flowData ? flowData : getFlowItems();

  if (!flowItems || flowItems.length === 0) {
    return null;
  }

  return (
    <div className="card-flow-dynamic-container d-flex align-items-center justify-content-center gap-3">
      {flowItems.map((item, index) => (
        <React.Fragment key={item.Sequencia || index}>
          <div className="d-flex align-items-center gap-2">
            {item.Logo_Empresa ? (
              <div className="card-flow-logo-wrapper">
                <img
                  src={item.Logo_Empresa}
                  alt={item.Nome_Empresa}
                  className="card-flow-logo"
                />
              </div>
            ) : (
              <i
                className="far fa-user-circle user-photo-label"
                aria-hidden="true"
              />
            )}
            <div className="flow-item d-flex flex-column">
              <TextWithTooltip id={`flow-${index}`} textFull={item.Nome_Empresa} text={(item.Nome_Empresa.length > 14 ? item.Nome_Empresa.charAt(0).toUpperCase() + item.Nome_Empresa.slice(1, 14).toLowerCase() + '...' : item.Nome_Empresa.charAt(0).toUpperCase() + item.Nome_Empresa.toLowerCase().slice(1))} classname="card-flow-name" />
              {item.Porte_Empresa && (
                <span className="card-flow-size text-muted small">
                  {item.Porte_Empresa.charAt(0).toUpperCase() + item.Porte_Empresa.toLowerCase().slice(1)}
                </span>
              )}
            </div>
          </div>
          {index < flowItems.length - 1 && (
            <i className="bx bx-right-arrow-alt card-flow-arrow"></i>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CardFlowDynamic;
